import { render } from "./PannDettInterventiStoricoRiga.vue?vue&type=template&id=4927fb9f"
import script from "./PannDettInterventiStoricoRiga.vue?vue&type=script&lang=js"
export * from "./PannDettInterventiStoricoRiga.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__